import React, { useState, useEffect } from 'react';
import { getWorkoutPlan, logWorkoutSession } from '../api';

const WorkoutSession = ({ planId, memberId }) => {
    const [plan, setPlan] = useState(null);
    const [currentExerciseIndex, setCurrentExerciseIndex] = useState(0);
    const [completedExercises, setCompletedExercises] = useState([]);
    const [notes, setNotes] = useState('');
    const [timer, setTimer] = useState(0);

    useEffect(() => {
        const fetchPlan = async () => {
            try {
                const response = await getWorkoutPlan(planId);
                setPlan(response.data);
            } catch (error) {
                console.error('Failed to fetch workout plan', error);
            }
        };
        fetchPlan();
    }, [planId]);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimer(prevTimer => prevTimer + 1);
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    const completeExercise = () => {
        const exercise = plan.exercises[currentExerciseIndex];
        setCompletedExercises([...completedExercises, exercise]);
        if (currentExerciseIndex < plan.exercises.length - 1) {
            setCurrentExerciseIndex(currentExerciseIndex + 1);
        } else {
            // End of workout
        }
    };

    const logSession = async () => {
        const sessionData = {
            plan_id: planId,
            member_id: memberId,
            date: new Date().toISOString().slice(0, 10),
            exercises_completed: completedExercises,
            notes: notes,
            completion_status: 'Completed'
        };
        try {
            await logWorkoutSession(sessionData);
            // Add success message or redirect
        } catch (error) {
            console.error('Failed to log workout session', error);
        }
    };

    if (!plan) {
        return <div>Loading...</div>;
    }

    const currentExercise = plan.exercises[currentExerciseIndex];

    return (
        <div className="container mx-auto p-4">
            <h1 className="text-2xl font-bold mb-4">Workout Session</h1>
            <div className="text-center text-4xl font-bold mb-4">{Math.floor(timer / 60)}:{('0' + timer % 60).slice(-2)}</div>
            <div className="p-4 border rounded mb-4">
                <h2 className="text-xl font-semibold">{currentExercise.name}</h2>
                <p>Sets: {currentExercise.sets}, Reps: {currentExercise.reps}, Weight: {currentExercise.weight}, Rest: {currentExercise.rest_time}</p>
            </div>
            <button onClick={completeExercise} className="bg-green-500 text-white px-4 py-2 rounded mr-2">Complete Exercise</button>
            <button onClick={logSession} className="bg-blue-500 text-white px-4 py-2 rounded">Log Session</button>
            <textarea placeholder="Notes" value={notes} onChange={(e) => setNotes(e.target.value)} className="w-full p-2 mt-4 border rounded"></textarea>
        </div>
    );
};

export default WorkoutSession;
